export const SCROLL_THRESHOLD = 100;
